module.exports = __webpack_public_path__ + "static/media/refer-prof-holding-map-graphic.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Refer/img/refer-prof-holding-map-graphic.svg
// module id = 520
// module chunks = 0